<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      title="创建 订单"
      id-key="OrderId"
      :data="data"
      :form-rules="rules"
      :save-func="()=>{}"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12" v-if="data.OperId">
            <el-form-item label="单据编号" prop="OrderNo">
              <el-input v-model="data.OrderNo" placeholder="请输入单据编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="data.OperId">
            <el-form-item label="单据日期" prop="OrderDate">
              <el-date-picker
                type="date"
                v-model="data.OrderDate"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="批发客户" prop="TradeUnitId">
              <select-input
                v-if="!data.OperId"
                placeholder="请选择批发客户"
                :label="data.TradeUnitName"
                v-model="data.TradeUnitId"
                @click="openWholesaler"
              />
              <span v-else>{{data.TradeUnitName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="余额">
              <span>{{data.Balance}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="信用额度">
              <span>{{data.Limit}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="配送方式">
              <el-radio-group v-model="data.IsPickSelf" v-if="!data.OperId">
                <el-radio :label="false">快递配送</el-radio>
                <el-radio :label="true">到店自提</el-radio>
              </el-radio-group>
              <span v-else>{{data.IsPickSelf?'到店自提':'快递配送'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!data.IsPickSelf">
          <el-col :span="24">
            <el-form-item label="配送地址" prop="AddressId">
              <template v-if="!data.OperId">
                <el-select v-model="data.AddressId" placeholder="请选择" style="width: 100%;">
                  <template v-for="(i,key) in Address">
                    <el-option :key="key" :label="i.FullAddress" :value="i.AddressId"></el-option>
                  </template>
                </el-select>
              </template>
              <span v-else>{{fullAddress}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="data.OperId">
          <el-col :span="8" v-if="data.Freight!=0">
            <el-form-item label="快递费用">
              <span>{{data.Freight}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品总价">
              <span>{{data.GoodsAmount}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合计金额">
              <span style="color: #ff9a02;">{{data.Amount}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>商品信息</el-divider>
        <el-table border :data="data.Goods" style="width: 100%">
          <el-table-column prop="GoodsName" label="商品名称" min-width="200px" />
          <el-table-column prop="Price" label="单价" min-width="110px">
            <template slot-scope="{row}">
              <el-input v-if="!data.OperId" @input="onInput(row)" v-model="row.Price"></el-input>
              <span v-else>{{row.Price}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="Quantity1" label="数量" min-width="100px">
            <template slot-scope="{row}">
              <el-input v-if="!data.OperId" @input="onInput(row)" v-model="row.Quantity1"></el-input>
              <span v-else>{{row.Quantity1}}</span>
            </template>
          </el-table-column>-->
          <!-- <el-table-column prop="Quantity" label="主单位数量" width="90px" /> -->
          <!-- <el-table-column prop="UnitName" label="主单位" /> -->
          <el-table-column prop="Quantity1" label="销售数量" width="90px">
            <template slot-scope="{row}">
              <el-input
                v-if="!data.OperId"
                v-model="row.Quantity1"
                type="number"
                @input="count(row)"
                @blur="onBlur(row,'Quantity1')"
                @focus="onFocus(row,'Quantity1')"
              ></el-input>
              <span v-else>{{row.Quantity1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="UnitName1" label="销售单位" />
          <el-table-column prop="Amount" v-if="data.OperId" label="金额" min-width="120px" />
          <el-table-column fixed="right" align="center" width="80px" v-show="!data.OperId">
            <template slot="header">
              <i class="el-icon-circle-plus-outline add-icon" @click="addGoods"></i>
            </template>
            <template slot-scope="{$index}">
              <el-button icon="el-icon-delete" type="text" @click="delGoods($index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 15px;" v-if="noSubmit">
          <el-alert title="客户余额与可用额度不足，无法提交支付" type="warning" :closable="false"></el-alert>
        </div>
      </template>
      <template slot="footer">
        <el-button v-if="!data.OperId" type="primary" @click="settle">结 算</el-button>
        <template v-else>
          <el-button type="success" :disabled="noSubmit" @click="submit">提交支付</el-button>
          <el-button type="danger" @click="cancel">取消结算</el-button>
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
      <wholesaler-dialog ref="wholesalerDialog" in-dialog selectable @select="setWholesaler" />
      <goods-dialog ref="goodsDialog" in-dialog selectable multiple @select-multiple="setGoods" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import wholesalerDialog from "@/components/sales/customer/manage/listDialog";
// import goodsDialog from "@/components/sales/customer/manage/goods/listDialog";
import goodsDialog from "@/components/mall/goods/mallgoods/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    wholesalerDialog,
    goodsDialog,
  },
  data() {
    return {
      api: require("@/api/mall/order").default,
      address_api: require("@/api/ba/address").default,
      unit_api: require("@/api/goods/multiUnit").default,
      // goods_api: require("@/api/ba/wholesalerGoods").default,
      data: {
        OrderNo: "",
        OrderDate: this.$commonJs.getToday(),
        Cart: false,
        CouponCustomerId: 0,
        AddressId: null,
        IsPickSelf: false,
        TradeUnitId: null,
        TradeUnitName: "",
        Goods: [],

        OperId: null,
        IsSystem: true,
        Freight: 0,
        GoodsAmount: 0,
        Amount: 0,
        RemainAmount: 0, //大于0时，订单不能提交 (RemainAmount=订单金额-额度-余额)
        Balance: 0, //余额
        Limit: 0, //赊账额度
      },
      Address: [],
      rules: {
        TradeUnitId: [{ required: true, message: "请选择批发客户" }],
        AddressId: [{ required: true, message: "请选择配送地址" }],
        OrderDate: [{ required: true, message: "请选择单据时间" }],
      },
    };
  },
  computed: {
    fullAddress() {
      var address = this.Address.find(
        (x) => x.AddressId == this.data.AddressId
      );
      if (address) return address.FullAddress;
      else return "";
    },
    noSubmit() {
      return this.data.RemainAmount > 0;
    },
  },
  methods: {
    onDetailsOpened(data) {
      // var params = { OrderId: this.data.OrderId };
      // this.ogApi.list(params).then((res) => {
      //   if (res.Data) this.OrderGoods = res.Data;
      // });
      // this.olApi.list(params).then((res) => {
      //   if (res.Data) this.OrderLog = res.Data;
      // });
      // this.api.getDeliverDocList(this.data.OrderId).then((res) => {
      //   if (res.Data) this.DeliverList = res.Data;
      // });
      // if (data.RefundStatus > 0) {
      //   this.rgApi.list(params).then((res) => {
      //     if (res.Data) this.RefundList = res.Data;
      //   });
      // }
    },
    openWholesaler() {
      this.$refs.wholesalerDialog.open().then((that) => {
        that.getTree();
        that.getData({ Status: 1 });
      });
    },
    setWholesaler(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.TradeUnitName;
      this.data.Balance = data.Balance; //余额
      this.data.Limit = data.Limit; //赊账额度
      var param = {
        TradeUnitId: data.TradeUnitId,
      };
      this.address_api.list(param).then((res) => {
        if (res.Code == 0) {
          this.Address = res.Data.map((x) => {
            var full = x.Person + " " + x.Phone + " " + x.ProvinceName + " ";
            full += x.CityName + " " + x.DistrictName + " " + x.Address;
            return { ...x, FullAddress: full };
          });
        }
      });
    },
    addGoods() {
      if (!this.data.TradeUnitId) {
        this.$message.warning("请先选择批发客户");
        return;
      }
      if (!this.data.IsPickSelf && !this.data.AddressId) {
        this.$message.warning("请选择配送地址");
        return;
      }
      var ids = this.data.Goods.map((x) => x.GoodsId);
      this.$refs.goodsDialog.open().then((that) => {
        that.getData({
          TradeUnitId: this.data.TradeUnitId,
          NoIds: ids,
        });
      });
    },
    setGoods(data) {
      console.log("setGoods", data);
      data.forEach((x) => {
        this.data.Goods.push({
          ...x,
          Price: x.RetailPrice,
          Quantity: 1,
          Quantity1: 1,
          UnitId: x.MainUnitId,
          UnitName: x.MainUnitName,
          UnitId1: x.SaleUnitId,
          UnitName1: x.SaleUnitName,
        });
      });
    },
    delGoods(index) {
      this.data.Goods.splice(index, 1);
    },
    settle() {
      if (!this.data.TradeUnitId) {
        this.$message.warning("批发客户不能为空");
        return;
      }
      if (!this.data.IsPickSelf && !this.data.AddressId) {
        this.$message.warning("配送地址不能为空");
        return;
      }
      if (this.data.Goods.length == 0) {
        this.$message.warning("请选择商品");
        return;
      }

      var data = { ...this.data, Goods: [] };
      if (data.AddressId == null) data.AddressId = 0;
      data.Goods = this.data.Goods.map((x) => {
        return {
          GoodsId: x.GoodsId,
          IsPickSelf: this.data.IsPickSelf,
          Price: x.Price,
          Quantity: x.Quantity,
          Quantity1: x.Quantity1,
          UnitId: x.UnitId,
          UnitName: x.UnitName,
          UnitId1: x.UnitId1,
          UnitName1: x.UnitName1,
        };
      });
      this.api.settle(data).then((res) => {
        if (res.Code == 0) {
          this.data.Goods = res.Data.Goods;
          this.data.OperId = res.Data.OperId;
          // this.data.IsPickSelf = res.Data.PickSelf;
          this.data.Freight = res.Data.Freight;
          this.data.GoodsAmount = res.Data.GoodsAmount;
          this.data.Amount = res.Data.Amount;
          this.data.RemainAmount = res.Data.RemainAmount;
          this.data.Balance = res.Data.Balance; //余额
          this.data.Limit = res.Data.Limit; //赊账额度
        } else if (res.Code == 2) {
          this.$message.error("不允许下单");
        }else if (res.Code == 3) {
          this.$message.error("没有地址");
        }  else if (res.Code == 4) {
          this.$message.error("有未付款订单");
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    submit() {
      var config = {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      };
      this.$confirm("确认提交吗？", "提示", config)
        .then(() => {
          this.api
            .submitV2({
              OperId: this.data.OperId,
              OrderNo: this.data.OrderNo,
              OrderDate: this.data.OrderDate,
            })
            .then((res) => {
              if (res.Code == 0) {
                this.$message.success(res.Msg);
                this.close(true);
                this.$emit("close-saved");
              } else {
                this.$message.error(res.Msg);
              }
            });
        })
        .catch(() => {});
    },
    unitChange(row, name) {
      console.log(row);
      row.Units.forEach((e) => {
        if (e.UnitId == row["UnitId" + name]) {
          row["Rate" + name] = e.Rate;
        }
      });
      this.count(row);
    },
    cancel() {
      this.data.OperId = null;
      this.data.IsPickSelf = false;
      this.data.Freight = 0;
      this.data.GoodsAmount = 0;
      this.data.Amount = 0;
      this.data.RemainAmount = 0;
      this.data.Balance = 0; //余额
      this.data.Limit = 0; //赊账额度
    },
    onInput(row) {
      row.Quantity = this.$commonJs.obj.toInt(row.Quantity);
    },
    onClosed() {
      this.data.Goods = [];
      this.Address = [];
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    count(row) {
      // let price = row.Price ? Number(row.Price) : 0;
      // let dis = row.Discount > 0 ? Number(row.Discount) : 100;
      // let dis = 100;
      let qua = row.Quantity1 ? Number(row.Quantity1) : 0;
      // let rate = row.TaxRate ? Number(row.TaxRate) : 0;
      // let rate = 0;
      // let ref = row.ReferenceCost ? Number(row.ReferenceCost) : 0;
      // if (row.T !== 0) row.T = 1;
      // row.Price = dis
      //   ? (row.Price * (dis / 100) * (1 + rate / 100)).toFixed(2)
      //   : (row.Price * (1 + rate / 100)).toFixed(2);
      // console.log("price", row.Price);
      // row.Amount = ((row.Price * qua * 100) / 100).toFixed(2);
      // row.NoTaxAmount = (row.Offer * (dis / 100) * row.Quantity1).toFixed(2);
      // row.TaxAmount =
      //   (
      //     (qua *
      //       (((dis ? row.Offer * (dis / 100) : row.Offer) * rate) / 100) *
      //       100) /
      //     100
      //   ).toFixed(2) || 0;
      // row.GrossProfit = (row.Amount - qua * ref).toFixed(2);
      row.Quantity = (1 / row.Rate) * qua;
      // if (row.UnitId2 == row.UnitId) {
      //   row.Quantity2 = row.Quantity;
      // } else {
      //   console.log(row.Rate2, row.Quantity);
      //   if (!row.Rate2) {
      //     row.Quantity2 = 0;
      //   } else {
      //     row.Quantity2 = row.Rate2 * row.Quantity;
      //   }
      // }
      // this.subTable();
    },
  },
};
</script>